/**
 * Best-time persistence in localStorage.
 *   key: solar-installer:best:<levelId>
 *   value: integer milliseconds
 *
 * Stays best-effort — if storage is unavailable (private mode, etc.) the
 * helpers return undefined and store nothing.
 */

const KEY_PREFIX = 'solar-installer:best:';

export function getBest(levelId: number): number | undefined {
  try {
    const v = localStorage.getItem(KEY_PREFIX + levelId);
    if (v == null) return undefined;
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : undefined;
  } catch {
    return undefined;
  }
}

export function recordTime(levelId: number, ms: number): boolean {
  try {
    const prev = getBest(levelId);
    if (prev == null || ms < prev) {
      localStorage.setItem(KEY_PREFIX + levelId, String(ms));
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

export function formatTime(ms: number): string {
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
